/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { forwardRef } from "react";
import { cn } from "tailwind-variants";
import { useI18n } from "intl/useI18n";
import "./JiffyPromotionBlanks.scss";
import FreeShippingTruckIcon from "assets/icons/free-shipping-truck.svg";
import JiffyShirtsInlineIcon from "assets/icons/jiffy-shirts-inline.svg";

const JiffyPromotionBlanks = forwardRef<HTMLAnchorElement, any>(
  ({ spendThreshold, openInNewTab = true, ...restProps }, ref) => {
    const { n } = useI18n();

    function isMobileApp() {
      return Boolean(window.MOBILE_APP);
    }

    function openInSameTab() {
      return isMobileApp() || !openInNewTab;
    }

    return (
      <a
        {...restProps}
        ref={ref}
        className={cn(
          "jiffy-promotion-blanks js-jiffy-promotion scope-fb9740ef",
          // @ts-expect-error TS(4111): Property 'className' comes from an index signature... Remove this comment to see the full error message
          restProps.className
        )}
        href="/?seller=JiffyShirts"
        target={openInSameTab() ? "_self" : "_blank"}
        rel={openInSameTab() ? undefined : "noreferrer"}
        data-mixpanel-listen="click"
        data-mixpanel-event="crosssell_cta_blanks_free_shipping_offer_click"
        data-mixpanel-data={JSON.stringify({
          page: "cart",
          business_line_promo_type: "Blanks",
          promotion_name: `spend_${spendThreshold}_get_free_shipping`
        })}
        data-testid="jiffy-promotion-blanks"
      >
        <div className="jiffy-promotion-blanks__free-shipping-wrapper scope-fb9740ef">
          <FreeShippingTruckIcon
            className="jiffy-promotion-blanks__free-shipping-icon scope-fb9740ef"
            data-testid="jiffy-promotion-blanks-free-shipping-icon"
          />
          <span className="scope-fb9740ef">FREE SHIPPING</span>
        </div>
        <div className="jiffy-promotion-blanks__info-wrapper scope-fb9740ef">
          <div className="jiffy-promotion-blanks__info scope-fb9740ef">
            <JiffyShirtsInlineIcon
              className="jiffy-promotion-blanks__logo-icon scope-fb9740ef"
              data-testid="jiffy-promotion-blanks-logo-icon"
            />
            <p className="jiffy-promotion-blanks__info-text scope-fb9740ef">
              {" "}
              Spend {n(spendThreshold, "currencyNoCents")}+ on DTF,{" "}
              <strong className="scope-fb9740ef">get free shipping for blank apparel</strong>{" "}
              shipped from Jiffy!{" "}
            </p>
          </div>
        </div>
      </a>
    );
  }
);

JiffyPromotionBlanks.displayName = "JiffyPromotionBlanks";

export default JiffyPromotionBlanks;
